import { render, staticRenderFns } from "./VergiNumarasi.vue?vue&type=template&id=0859f19e&scoped=true"
import script from "./VergiNumarasi.vue?vue&type=script&lang=ts"
export * from "./VergiNumarasi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0859f19e",
  null
  
)

export default component.exports